import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id, e) => {
    const element = document.getElementById(id);
    if (element) {
      if (e) e.preventDefault();
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <>
      <footer className="bg-slate-900 text-slate-300 py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-white font-semibold mb-4">Smart Post Solution</h3>
              <p className="text-sm leading-relaxed">
                Senior Consultant für Briefkonsolidierung, Versandlogistik und Poststellenorganisation
              </p>
            </div>
            
            <div>
              <h3 className="text-white font-semibold mb-4">Navigation</h3>
              <div className="text-sm space-y-2">
                <a href="/#ueber-uns" onClick={(e) => scrollToSection('ueber-uns', e)} className="hover:text-white transition-colors block text-left">Über mich</a>
                <a href="/#leistungen" onClick={(e) => scrollToSection('leistungen', e)} className="hover:text-white transition-colors block text-left">Leistungen</a>
                <a href="/#arbeitsweise" onClick={(e) => scrollToSection('arbeitsweise', e)} className="hover:text-white transition-colors block text-left">Arbeitsweise</a>
                <a href="/#kontakt" onClick={(e) => scrollToSection('kontakt', e)} className="hover:text-white transition-colors block text-left">Kontakt</a>
              </div>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-4">Kontakt</h3>
              <div className="text-sm space-y-3">
                <div className="flex items-center gap-2">
                  <Mail size={14} className="flex-shrink-0" />
                  <a href="/#kontakt" onClick={(e) => scrollToSection('kontakt', e)} className="hover:text-white transition-colors">Kontaktformular</a>
                </div>
                <div className="flex items-center gap-2">
                  <Phone size={14} className="flex-shrink-0" />
                  <a href="tel:+497235975942" className="hover:text-white transition-colors">07235 - 9759-427</a>
                </div>
                <div className="flex items-center gap-2">
                  <Phone size={14} className="flex-shrink-0" />
                  <a href="tel:+4915233886484" className="hover:text-white transition-colors">0152 33 88 64 84</a>
                </div>
                <div className="flex items-start gap-2">
                  <MapPin size={14} className="flex-shrink-0 mt-0.5" />
                  <span>Unterreichenbacher Str. 3, 75331 Engelsbrand</span>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-white font-semibold mb-4">Rechtliches</h3>
              <div className="text-sm space-y-2">
                <Link to="/impressum" className="hover:text-white transition-colors block text-left" data-testid="footer-impressum-link">Impressum</Link>
                <Link to="/datenschutz" className="hover:text-white transition-colors block text-left" data-testid="footer-datenschutz-link">Datenschutz</Link>
              </div>
            </div>
          </div>
          
          <div className="pt-8 border-t border-slate-800">
            <div
              aria-hidden="true"
              className="flex justify-center select-none pointer-events-none"
              data-testid="footer-watermark"
            >
              <span
                className="font-bold tracking-tight whitespace-nowrap leading-none"
                style={{
                  fontSize: 'clamp(2.4rem, 9.4vw, 7.5rem)',
                  color: 'transparent',
                  WebkitTextStroke: '1px rgba(255, 255, 255, 0.45)',
                  letterSpacing: '0.01em',
                  WebkitMaskImage:
                    'linear-gradient(to bottom, #000 55%, rgba(0,0,0,0.35) 80%, transparent 100%)',
                  maskImage:
                    'linear-gradient(to bottom, #000 55%, rgba(0,0,0,0.35) 80%, transparent 100%)',
                }}
              >
                Smart-Post-Solution
              </span>
            </div>

            <p className="text-sm text-center mt-2">
              &copy; {currentYear} Smart Post Solution. Alle Rechte vorbehalten.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
